module.exports = __webpack_public_path__ + "static/media/bottom.3162ab04.png";